import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import AccountMenuComponent from "../../../lib/bandung/components/AccountMenu/AccountMenuComponent";
const DesktopNavigation = ({ navLinks }) => {
  return (
    <div>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          gap: 1, // Space between buttons
          alignItems: "center",
        }}
      >
        {navLinks.map((navItem) => (
          <Link key={navItem.key} href={navItem.url} underline="none">
            <Button
              key={navItem.key}
              variant="text"
              sx={{
                color: "black",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.1)",
                  boxShadow: "none",
                },
              }}
            >
              {navItem.displayName}
            </Button>
          </Link>
        ))}
        <AccountMenuComponent className="text-black" />
      </Box>
    </div>
  );
};

export default DesktopNavigation;
